"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DataTypePicker;
var _ExpandLess = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _Collapse = _interopRequireDefault(require("@mui/material/Collapse/Collapse.js"));
var _List = _interopRequireDefault(require("@mui/material/List/List.js"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem/ListItem.js"));
var _Popover = _interopRequireDefault(require("@mui/material/Popover/Popover.js"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField/TextField.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _uniq = _interopRequireDefault(require("lodash/uniq"));
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
var _react = _interopRequireWildcard(require("react"));
var _architectureTypes = require("../types/architectureTypes");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _makeStyles.default)(({
  palette,
  spacing
}) => ({
  buttonWrap: {
    display: 'flex',
    alignItems: 'center',
    '& > *:first-child': {
      marginRight: spacing()
    }
  },
  header: {
    width: '100%',
    padding: spacing(1, 1, 0)
  },
  categoryWrap: {
    height: '70vh',
    overflow: 'hidden auto',
    width: '350px'
  },
  emptyText: {
    fontStyle: 'italic',
    color: palette.grey['500']
  }
}));
function DataTypePicker({
  semanticTypes,
  selectedId,
  onChange
}) {
  const {
    types,
    categoryNames
  } = splitTypesAndCategories(semanticTypes);
  const [open, setOpen] = (0, _react.useState)(false);
  const [searchString, setSearchString] = (0, _react.useState)('');
  const anchorRef = (0, _react.useRef)(null);
  const classes = useStyles();
  const searchTimeout = (0, _react.useRef)();
  const [debounced, setDebounced] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    clearTimeout(searchTimeout?.current);
    searchTimeout.current = setTimeout(() => {
      setDebounced(searchString);
    }, 500);
  }, [searchString]);
  const filteredTypes = debounced ? types?.filter(t => t.name.toLowerCase().includes(debounced)) : types;
  const categoryTypes = categoryNames?.map(c => ({
    name: c,
    types: filteredTypes?.filter(t => t.categoryName === c)
  }));
  const type = types?.length && types.find(t => t.id === selectedId);
  function handleChange(typeId) {
    setOpen(false);
    setSearchString('');
    onChange(typeId);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: classes.buttonWrap,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        variant: "caption",
        children: "Data Type: "
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.default, {
        size: "small",
        variant: "outlined",
        ref: anchorRef,
        onClick: () => setOpen(true),
        children: [type ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
            variant: "caption",
            children: [type.name, "\xA0(", type.type, ")"]
          })
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: "caption",
          className: classes.emptyText,
          children: "Select"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandMore.default, {})]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Popover.default, {
      anchorEl: anchorRef.current,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      open: open,
      onClose: () => setOpen(false),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: classes.header,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            variant: "caption",
            children: "Semantic Data Types"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
            autoFocus: true,
            fullWidth: true,
            onChange: e => setSearchString(e.target.value.toLowerCase()),
            placeholder: "Search",
            value: searchString,
            variant: "standard"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: classes.categoryWrap,
          children: categoryTypes?.map(c => /*#__PURE__*/(0, _jsxRuntime.jsx)(SubList, {
            category: c,
            forceOpen: Boolean(debounced),
            onChange: handleChange
          }, c.name))
        })]
      })
    })]
  });
}
const useSubListStyles = (0, _makeStyles.default)(({
  spacing,
  palette
}) => ({
  category: {
    padding: '2px 8px'
  },
  categoryText: {
    flex: 1,
    overflow: 'hidden',
    color: palette.primary.dark
  },
  icon: {
    color: palette.primary.dark
  },
  listItem: {
    padding: spacing(0, 1),
    display: 'block'
  },
  description: {
    fontSize: '0.7em',
    paddingLeft: spacing(0.5)
  }
}));
function SubList({
  category,
  forceOpen,
  onChange
}) {
  const [open, setOpen] = (0, _react.useState)(false);
  const classes = useSubListStyles();
  const {
    name,
    types
  } = category;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItem.default, {
      button: true,
      className: classes.category,
      disabled: types.length === 0,
      onClick: () => setOpen(s => !s),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        className: classes.categoryText,
        children: name
      }), open || forceOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandLess.default, {
        className: classes.icon,
        fontSize: "small"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandMore.default, {
        className: classes.icon,
        fontSize: "small"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Collapse.default, {
      in: types.length > 0 && (open || forceOpen),
      mountOnEnter: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.default, {
        disablePadding: true,
        children: types.map(type => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItem.default, {
          button: true,
          className: classes.listItem,
          onClick: () => onChange(type.id),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
            display: "flex",
            alignItems: "center",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
              variant: "caption",
              children: type.name
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
              className: classes.description,
              children: [" (", type.type, ")"]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            className: classes.description,
            children: type.description
          })]
        }, type.id))
      })
    })]
  });
}
function splitTypesAndCategories(semanticTypes) {
  if (!semanticTypes) return {};
  const types = (0, _uniqBy.default)(semanticTypes.map(({
    type,
    ...rest
  }) => ({
    ...rest,
    type: type === _architectureTypes.PropertyType.QUANTITATIVE ? 'Metric' : 'Element'
  })).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())), 'name');
  const categoryNames = (0, _uniq.default)(['General', 'GeneralText', ...types.map(c => c.categoryName).sort((a, b) => a.localeCompare(b))]);
  return {
    types,
    categoryNames
  };
}